// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2rko14q2{border-radius:var(--ds-border-radius-circle,2002pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/EmbedCard/components/ImageIcon.compiled.css"],"names":[],"mappings":"AAAA,WAAW,mDAAmD","sourcesContent":["._2rko14q2{border-radius:var(--ds-border-radius-circle,2002pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
